export default __webpack_public_path__ + "static/media/line01.f6c7d722.jpg";